import * as React from "react";
const Loader = require("react-loader-spinner").default;
import { toast } from "react-toastify";
import * as Modal from "react-modal";
import hash from "../../assets/hash.png"

export default class Categories extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      categories: [],
      loading: false,
      modalOn: false,
      newCategory: {
        id: null,
        title: "",
      },
    };
  }

  loadCategories = () => {
    fetch("categories/getAll", {
      method: "POST",
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        this.setState({ categories: data.categories });
      })
      .catch((err) => {
        //toast.error(err.message);
      });
  };

  removeCategory = (id: number, index: number) => {
    const confirmed = confirm("אתה בטוח?");
    if (!confirmed) return;
    this.setState({ loading: true });
    fetch("categories/delete", {
      method: "POST",
      body: JSON.stringify({ id }),
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        let categories = this.state.categories;
        categories.splice(index, 1);
        this.setState({
          loading: false,
          categories,
        });
      })
      .catch((err) => {
        this.setState({ loading: false });
        toast.error(err.message);
      });
  };

  updateCategory = () => {
    const newCategory = this.state.newCategory;
    this.setState({ loading: true });
    fetch("categories/edit", {
      method: "POST",
      body: JSON.stringify(newCategory),
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        let categories = this.state.categories;
        if (newCategory.id) {
          const i = categories.findIndex((u: any) => {
            return u.id === newCategory.id;
          });
          categories[i] = data.category;
        } else {
          categories.unshift(data.category);
        }
        this.setState({
          loading: false,
          categories,
          modalOn: false,
        });
      })
      .catch((err) => {
        this.setState({ loading: false });
        toast.error(err.message);
      });
  };

  componentDidMount() {
    this.loadCategories();
  }

  public render() {
    const { categories } = this.state;
    return (
      <div id="campaigns-root">
        <Modal isOpen={this.state.modalOn} className="newCategory-modal">
          <a
            className="fa fa-times"
            onClick={() => {
              this.setState({
                modalOn: false,
                newCategory: { id: null, title: "" },
              });
            }}
          ></a>
          <input
            name="title"
            type="text"
            value={this.state.newCategory.title || ""}
            placeholder={"שם קטגוריה"}
            onChange={(e: any) => {
              let newCategory = this.state.newCategory;
              newCategory.title = e.target.value;
              this.setState({ newCategory });
            }}
          />
          <button
            className="submit"
            onClick={() => {
              this.updateCategory();
            }}
          >
            שמירה
          </button>
        </Modal>
        {this.state.loading && (
          <div className="loading">
            <Loader
              type="Oval"
              className="loader"
              color="#2f98e0"
              height={100}
              width={100}
            />
          </div>
        )}
        <div className="buttonsHeader">
        <i className="fa fa-bars" onClick={() => {this.props.openMenu()}}></i>
        <h1><img src={hash}></img>קטגוריות</h1>

          <button
            onClick={() => {
              this.setState({
                modalOn: true,
                newCategory: { id: null, title: "" },
              });
            }}
          >
            קטגוריה חדשה
          </button>
        </div>

        <div className="board">
          {categories.map((category: any, i: number) => {
            return (
              <div className="category" key={i}>
                <i
                  onClick={() => {
                    this.removeCategory(category.id, i);
                  }}
                  className="fas fa-trash"
                ></i>
                <span
                  onClick={() => {
                    this.setState({
                      newCategory: {
                        id: category.id,
                        title: category.title,
                      },
                      modalOn: true,
                    });
                  }}
                >
                  {category.title}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/categories/Categories.tsx